import { UserService } from '@/api/user'
import { CustomComponentContext, CustomComponentContextType } from '@/utils/contexts/CustomComponentContext'
import { useContext, useEffect } from 'react'

export default function HideManagerName() {
  const { setValue } = useContext<CustomComponentContextType>(CustomComponentContext)
  const { data: userData } = UserService.useGetProfile()

  useEffect(() => {
    if (userData) {
      setValue('manager', userData.manager)
      setValue('managerUsername', userData.managerUsername)
    }
  }, [userData, setValue])

  return <></>
}
